/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import { Alert } from 'react-bootstrap'
import * as H from 'history'
import React from 'react'
import Dropzone from 'react-dropzone'
import { ApplicationController } from '../../../controllers/ApplicationController'
import { DocumentReformController } from '../../../controllers/DocumentReformController'
import { ApplicationDocumentModel } from '../../../models/ApplicationDocumentModel'
import { ApplicationModel } from '../../../models/ApplicationModel'
import { ISupportSpinner } from '../../../shared/Ajax'
import { Backdrop } from '../../../shared/Backdrop'
import { NumericSelectField, TextField, validateFields } from '../../../shared/fields'
import { TableBody, TableColumn } from '../../../shared/table'
import { newGuid, Salutation } from '../../../shared/Utility'
import { SaveCancelButtons } from '../../applicationForm-1/controls/SaveCancelButtons'
import { DocumentTypeInfo, documentTypeInfo } from './DocumentTypeInfo'

interface FileData {
    file: File,
    key: string
}

export interface DocumentUploadPageProps {
    history: H.History
    model: ApplicationModel
    code: string
    item: string
    preview?: boolean
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
}

export interface DocumentUploadPageState {
    fileData: FileData[]
    loading: boolean
}

export class DocumentUploadPage extends React.Component<DocumentUploadPageProps, DocumentUploadPageState> implements ISupportSpinner {
  ajax: ApplicationController
  docAjax: DocumentReformController
  applicantTitle: NumericSelectField
  applicantFirstName: TextField
  applicantLastName: TextField

  constructor(props: DocumentUploadPageProps) {
    super(props)
    this.ajax = new ApplicationController()
    this.docAjax = new DocumentReformController()
    this.state = {
      fileData: [],
      loading: false,
    }
  }

  getItems = () => {
    const { model, code } = this.props
    return model.applicationDocuments ? model.applicationDocuments.filter((d) => d.code === code) : []
  }

  uploadFiles = (info: DocumentTypeInfo) => {
    const { model, item, code } = this.props
    const { fileData } = this.state
    const multiple = info.multipleFiles(model, item)
    this.setState({ loading: true }, () => {
      const formData = new FormData()
      formData.append('ApplicationId', model.applicationID)
      formData.append('code', code)
      formData.append('itemId', item)
      formData.append('multiple', multiple ? 'true' : 'false')
      formData.append('folder', info.folderName)
      for (const i in fileData) {
        formData.append('files', fileData[i].file)
      }

      if (!multiple) {
        const uploadedFiles = this.getItems()
        uploadedFiles.map((file) => {
          this.docAjax.delete(null, this.props.model.applicationID, file.blobID, (d: ApplicationDocumentModel[]) => {
            this.props.onChange({ applicationDocuments: d })
          })
        })
      }

      fetch('/api/documentreform/upload', {
        method: 'POST',
        body: formData,
      }).then((v) => {
        if (!v.ok) {
          this.setState({ loading: false }, () => {
            alert(v.statusText)
          })
          return
        }
        v.json().then((savedDocuments: ApplicationDocumentModel[]) => {
          this.props.onChange({ applicationDocuments: savedDocuments }, () => {
            this.props.history.goBack()
          })
        })
      })
    })
  }

  save = (info: DocumentTypeInfo) => {
    const { model, code } = this.props
    validateFields(
      (res) => {
        if (!res) {
          return
        }

        if (code === 'applicant_declaration') {
          this.ajax.updateApplication(this, model, () => {
            this.uploadFiles(info)
          })
        } else {
          this.uploadFiles(info)
        }
      },
      this.applicantTitle,
      this.applicantFirstName,
      this.applicantLastName,
    )
  }

  addFiles = (files: File[], info: DocumentTypeInfo) => {
    const { model, item } = this.props
    if (files.length === 0) {
      alert('No valid files have been selected. Please upload valid pdf file(s).')
      return
    }

    if (files.filter((f) => f.size > 10485755).length > 0) {
      alert('The selected file(s) could not be uploaded as one or more of the selected file(s) exceeds the maximum file size limit of 10MB.')
      return
    }

    if (files.filter((f) => f.name.length > 144).length > 0) {
      alert('The selected file(s) could not be uploaded as one or more of the selected file names exceeds the maximum allowed limit of 144 characters.')
      return
    }

    if (files.filter((f) => f.name.indexOf('+') >= 0).length > 0) {
      alert('A filename with \'+\' character is not allowed. Please rename the file before uploading.')
      return
    }

    const fileData: FileData[] = []
    for (const i in files) {
      const key = newGuid()
      fileData.push({ key, file: files[i] })
    }

    if (info.multipleFiles(model, item)) {
      this.setState({ fileData: [...this.state.fileData, ...fileData] })
    } else {
      this.setState({ fileData })
    }
  }

  downloadFile(blobId: string) {
    window.open(`/api/DocumentReform/download?applicationId=${this.props.model.applicationID}&blobid=${blobId}`, '_blank')
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  removeFile(key: string) {
    const { fileData } = this.state
    const newFileList = fileData.filter((f) => f.key !== key)

    this.setState({ fileData: newFileList })
  }

  removeUploadedFile(blobId: string) {
    if (confirm('Are you sure you want to delete the uploaded file?')) {
      this.docAjax.delete(null, this.props.model.applicationID, blobId, (d: ApplicationDocumentModel[]) => {
        this.props.onChange({ applicationDocuments: d })
      })
    }
  }

  columnsFileData: TableColumn<FileData>[] = [
    { name: 'New files', content: (r) => r.file.name },
    {
      name: '', content: (r) => <a href="#" onClick={(e) => { e.preventDefault(); this.removeFile(r.key) }}>Remove</a>,
    },
  ]

  columns: TableColumn<ApplicationDocumentModel>[] = [
    { name: 'Saved files', content: (r) => <a href="#" onClick={(e) => { e.preventDefault(); this.downloadFile(r.blobID) }}>{r.documentName}</a> },
    { name: '', content: (r) => <a className="float-right" href="#" onClick={(e) => { e.preventDefault(); this.removeUploadedFile(r.blobID) }}>Remove</a> },
  ]

  render() {
    const salutationDataSource = [
      { value: Salutation.Mr, label: 'Mr' },
      { value: Salutation.Mrs, label: 'Mrs' },
      { value: Salutation.Miss, label: 'Miss' },
      { value: Salutation.Ms, label: 'Ms' },
      { value: Salutation.Other, label: 'Other' },
    ]

    const {
      code, model, item, history, onChange,
    } = this.props
    const { fileData, loading } = this.state
    const temp = documentTypeInfo.filter((r) => r.code === code)
    const items = model.applicationDocuments ? this.getItems() : []
    if (temp.length === 0) {
      return <div>Not found</div>
    }
    const info = temp[0]

    const acceptMultiple = info.multipleFiles(model, item)

    return (
      <div>
        <SaveCancelButtons onCancel={history.goBack} onSave={() => this.save(info)} />

        <h4 className="mt-3 mb-3">{`Upload ${info.description(model, item)}`}</h4>
        <div className="mb-3">
          <Alert className="emdg-page-alerts">
            The maximum file size is 10MB. Only pdf files are allowed.
            <br />
            Maximum allowed file name length is 144 characters (including the extension).
            <br />
            Upload may take several minutes
          </Alert>
        </div>
        {info.moreInfo && (
        <div className="mb-3">
          <Alert className="emdg-page-alerts emdg-page-alerts--warning ">
            <div dangerouslySetInnerHTML={{ __html: info.moreInfo }} />
          </Alert>
        </div>
        )}
        <div className="mb-3" style={{ display: code === 'applicant_declaration' ? '' : 'none' }}>
          <h5>
            <a
              href={model.isConsultant
                ? 'https://www.austrade.gov.au/ArticleDocuments/1433/EMDG-Declaration-by-Consultant-Applicant.pdf.aspx'
                : 'https://www.austrade.gov.au/ArticleDocuments/1433/EMDG-Declaration-by-self-prepared-applicant.pdf.aspx'}
              target="_blank"
              rel="noreferrer"
            >
              If you have not completed the
              {model.isConsultant ? 'Consultant and Applicant Declaration' : 'Applicant Declaration'}
              {' '}
              document, click here to download a copy.
            </a>
          </h5>
          <p>What is the name of the person who signed the Applicant Declaration?</p>
          <NumericSelectField
            ref={(r) => { this.applicantTitle = r }}
            id="applicantTitle"
            label="Title"
            value={model.applicantModel.title}
            onChange={(title) => onChange({ applicantModel: { ...model.applicantModel, title } })}
            required={code === 'applicant_declaration'}
            dataSource={salutationDataSource}
          />
          <div className="clearfix">
            <TextField
              ref={(r) => { this.applicantFirstName = r }}
              className="float-left mr-3"
              id="applicantFirstName"
              label="First name"
              value={model.applicantModel.givenName}
              onChange={(givenName) => onChange({ applicantModel: { ...model.applicantModel, givenName } })}
              maxLength={50}
              required={code === 'applicant_declaration'}
            />
            <TextField
              ref={(r) => { this.applicantLastName = r }}
              className="float-left"
              id="applicantLastName"
              label="Last name"
              value={model.applicantModel.familyName}
              onChange={(familyName) => onChange({ applicantModel: { ...model.applicantModel, familyName } })}
              maxLength={50}
              required={code === 'applicant_declaration'}
            />
          </div>
        </div>

        <Dropzone multiple={acceptMultiple} accept="application/pdf" onDrop={(files) => this.addFiles(files, info)}>
          {({
            getRootProps, getInputProps, isDragAccept, isDragReject,
          }) => (
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div className={'form-file'
                                + `${isDragAccept ? ' form-file-valid' : ''}`
                                + `${isDragReject ? ' form-file-invalid' : ''}`}
              >
                Drag and drop files here, or click to select files.
              </div>
            </div>
          )}
        </Dropzone>

        <TableBody<ApplicationDocumentModel>
          id="documents"
          columns={this.columns}
          value={items}
          noRowsMessage={items.length > 0 ? 'Loading' : 'No document(s) uploaded'}
          alwaysShowAllRows
        />
        <TableBody<FileData>
          id="documents"
          columns={this.columnsFileData}
          value={fileData}
          noRowsMessage={loading ? 'Loading' : 'No new files uploaded'}
        />
        <SaveCancelButtons onCancel={history.goBack} onSave={() => this.save(info)} />

        <Backdrop on={loading} />
      </div>
    )
  }
}
